import(/* webpackMode: "eager" */ "/srv/panel/app/error.tsx");
